import { render, staticRenderFns } from "./ManagePageContainer.vue?vue&type=template&id=6202cb8a&scoped=true"
import script from "./ManagePageContainer.vue?vue&type=script&lang=ts"
export * from "./ManagePageContainer.vue?vue&type=script&lang=ts"
import style0 from "./ManagePageContainer.vue?vue&type=style&index=0&id=6202cb8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6202cb8a",
  null
  
)

export default component.exports